import {
    CREATE_APPLICATION_HOURS_STATS_PER_MONTH_REQUEST,
    CREATE_APPLICATION_HOURS_STATS_PER_MONTH_SUCCESS,
    CREATE_APPLICATION_HOURS_STATS_PER_MONTH_FAILURE,
    CREATE_APPLICATION_HOURS_STATS_PER_MONTH_RESET,
    CLEAR_APPLICATION_HOURS_STATS_PER_MONTH_ERRORS
} from './ManageAnalyticsTypes';

const initialApplicationHoursStatsPerMonthState = {
    loading: false,
    error: null,
    applicationHoursStatsPerMonth: []
    
};

export const createApplicationHoursStatsPerMonthReducer = (state = initialApplicationHoursStatsPerMonthState, action) => {
    switch (action.type) {
        // Create Analytics Per Month
        case CREATE_APPLICATION_HOURS_STATS_PER_MONTH_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
                   
            };

        case CREATE_APPLICATION_HOURS_STATS_PER_MONTH_SUCCESS:
            return {
                ...state,
                loading: false,
                applicationHoursStatsPerMonth: action.payload,
                error: null
            };

        case CREATE_APPLICATION_HOURS_STATS_PER_MONTH_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case CREATE_APPLICATION_HOURS_STATS_PER_MONTH_RESET:
            return {
                ...state,
                loading: false,
                applicationHoursStatsPerMonth: [],
                error: null
            };

        // Clear Errors
        case CLEAR_APPLICATION_HOURS_STATS_PER_MONTH_ERRORS:
            return {
                ...state,
                error: null 
            };

        default:
            return state;
    }
};

